import React from 'react'
import '../CSS/header.css'


function Header() {
  return (

    <div id='header'>
      <header>
        <nav>
          <div id='right'>
            <a href="tel:0502116999"><h2 id='title'>צימר רוני</h2></a>
            <a id='iconTelHeader' href="tel:0502116999"></a>
          </div>


          <div id='logo'></div>

          <ul>
            <li className='list'><a href="#about">קצת עלינו</a></li>
            <li className='list'><a href="#galery">גלריה</a></li>
            <li className='list'><a href="#contact">צור קשר</a></li>
          </ul>










        </nav>
      </header>
    </div>

  )
}

export default Header